/**
 * Customer quotes API calls.
 */

import client from './client';

export async function fetchQuotes(params = {}) {
  const { data } = await client.get('/quotes/', { params });
  return data;
}

export async function fetchQuote(id) {
  const { data } = await client.get(`/quotes/${id}/`);
  return data.data || data;
}

export async function createQuote(payload) {
  const { data } = await client.post('/quotes/', payload);
  return data.data || data;
}

export async function updateQuote(id, payload) {
  const { data } = await client.patch(`/quotes/${id}/`, payload);
  return data.data || data;
}

export async function refreshQuotePricing(id) {
  const { data } = await client.post(`/quotes/${id}/refresh/`);
  return data.data || data;
}

export async function fetchStaleItems(id) {
  const { data } = await client.get(`/quotes/${id}/stale-items/`);
  return data.data || [];
}

export async function convertToJob(id) {
  const { data } = await client.post(`/quotes/${id}/convert-to-job/`);
  return data.data || data;
}
